'use client';

import type { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { ClientProvider } from '@/contexts/client-context';
import { InvoiceProvider } from '@/contexts/invoice-context';
import { ProductProvider } from '@/contexts/product-context';
import { ExpenseProvider } from '@/contexts/expense-context';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { Toaster } from 'sonner';

const Providers = ({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) => {
  return (
    <SessionProvider
      session={session}
      refetchInterval={60 * 5}
      // baseUrl="https://invoice-easy.com/"
    >
      <ClientProvider>
        <InvoiceProvider>
          <ProductProvider>
            <ExpenseProvider>
              <NextThemesProvider
                attribute="class"
                defaultTheme="system"
                enableSystem
                disableTransitionOnChange
              >
                {children}
                <Toaster
                  position="bottom-center"
                  duration={4000}
                  expand={true}
                  richColors
                />
              </NextThemesProvider>
            </ExpenseProvider>
          </ProductProvider>
        </InvoiceProvider>
      </ClientProvider>
    </SessionProvider>
  );
};

export default Providers;
